import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import EditorPicks from '@/pages/home/components/EditorPicks';
import LatestMovies from '@/pages/home/components/LatestMovies';
import RankingBoard from '@/pages/home/components/RankingBoard';
import TopRated from '@/pages/home/components/TopRated';
import HiddenGems from '@/pages/home/components/HiddenGems';
import TopicCollections from '@/pages/home/components/TopicCollections';
import Discussion from '@/pages/home/components/Discussion';
import Newsletter from '@/pages/home/components/Newsletter';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main className="w-full">
        <Hero />
        <EditorPicks />
        <LatestMovies />
        <RankingBoard />
        <TopRated />
        <HiddenGems />
        <TopicCollections />
        <Discussion />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}